import React from "react";

import { Redirect, Route, Switch } from "react-router-dom";
import chart from "../component/chart/chart";
import Dashboard from "../pages/dashboard";
import Import from "../pages/import";
import LinkInitiatives from "../pages/linkInitiatives";
import Notfound from "../pages/notFound";
import SpotLight from "../pages/spotLight";
import Subscriptions from "../pages/subscriptions";

const Approutes = () => {
  return (
    <Switch>
      <Route exact path="/" component={Dashboard} />
      <Route exact path="/link-initiatives" component={LinkInitiatives} />
      <Route exact path="/humanize-work" component={chart} />
      <Route exact path="/resilience-analytics" component={SpotLight} />
      <Route exact path="/import" component={Import} />
      <Route exact path="/subscriptions" component={Subscriptions} />
      <Route path="/not-found" component={Notfound} />
      <Redirect path="*" to="/not-found" />
    </Switch>
  );
};

export default Approutes;
